export default function getNextDetailsSetp() {
  let detailsSetp = history.state?.detailsSetp;
  detailsSetp = detailsSetp ? detailsSetp + 1 : 1;
  return detailsSetp;
}
// 记录查看大图走了的步骤，方便返回上一步
export const getNextViewImageSetp = () => {
  let viewImageSetp = history.state?.viewImageSetp;
  viewImageSetp = viewImageSetp ? viewImageSetp + 1 : 1;
  return viewImageSetp;
};
